import { Injectable } from '@angular/core';
import { UrlService } from 'src/app/shared/services/url/url.service';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })

export class ShellUriService {
    private baseUrl: string;

    constructor(private urlService: UrlService, ) {
        this.baseUrl = environment.baseUrl;
    }

    shellInitialUri() {
        return this.urlService.combineUri(this.baseUrl, 'customers', 'initial');
    }

    userRefreshTokenUri(refresh: string) {
        let data = {
            "refresh": refresh
        }
        return this.urlService.combineUri(this.baseUrl, 'auth', 'token', 'refresh', data)
    }
}
